import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { clearingHousePropertiesType, clearingHousesType, sortingParamType } from '../../types';
import ClearingHouseRow from './ClearingHouseRow';
import SortControl from '../SortControl';
import './_styles_/ClearingHousesList.css';

ClearingHousesList.propTypes = {
    clearingHouses: clearingHousesType.isRequired,
    clearingHouseProps: clearingHousePropertiesType.isRequired,
    onSort: PropTypes.func.isRequired,
    sortingParam: sortingParamType.isRequired,
};

function ClearingHousesList(props) {
    const {
        clearingHouses,
        clearingHouseProps,
        onSort,
        sortingParam,
    } = props;
    const { t } = useTranslation();
    return (
        <div className="clearing-houses-list">
            <div className="rich-list-row rich-list-header clearing-houses-list--header">
                <div className="rich-list-row--arrow-mobile" />
                <div className="clearing-house-header--values--name">
                    <SortControl onChange={onSort} sortingParam={sortingParam} sortingKey="name">
                        {t('clearing-houses.list-header.name')}
                    </SortControl>
                </div>
                <div className="clearing-house-header--values--code">
                    <SortControl onChange={onSort} sortingParam={sortingParam} sortingKey="code">
                        {t('clearing-houses.list-header.code')}
                    </SortControl>
                </div>
                <div className="rich-list-row--arrow" />
            </div>
            {
                clearingHouses.length
                    ? clearingHouses.map((clearingHouse) => (
                        <ClearingHouseRow
                            clearingHouseProps={clearingHouseProps}
                            clearingHouse={clearingHouse}
                            key={clearingHouse.id}
                        />
                    ))
                    : (<div className="clearing-houses-no-items">{t('clearing-houses.no-items')}</div>)
            }
        </div>
    );
}

export default ClearingHousesList;
